var _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #ee1c25;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #ff0;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0H900V600H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "a",
    className: "cls-2",
    d: "M150,60l52.9,162.81L64.4,122.19H235.6L97.1,222.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "a-2",
    "data-name": "a",
    className: "cls-2",
    d: "M311.74,32.39l-5,56.84L277.37,40.3l52.51,22.33-55.61,12.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "a-3",
    "data-name": "a",
    className: "cls-2",
    d: "M381.53,99.11l-26.67,50.45-8.07-56.49,39.73,41-56.22-9.79Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "a-4",
    "data-name": "a",
    className: "cls-2",
    d: "M388.18,199.71l-44.93,35.18L358.92,180l19.57,53.6-47.34-31.86Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "a-5",
    "data-name": "a",
    className: "cls-2",
    d: "M310.59,241.93l-2.65,57-31.36-47.67L330,271.4l-55,15.09Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/cn.eaec57fd8cfea43555bffaa9da92db7b.svg";
export { ForwardRef as ReactComponent };